import { render } from "./PoliticaReposicionModal.vue?vue&type=template&id=4c03666d"
import script from "./PoliticaReposicionModal.vue?vue&type=script&lang=js"
export * from "./PoliticaReposicionModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__